import Navbar from "@/pages/home/components/Navbar";
import CapabilitiesSection from "@/pages/home/components/CapabilitiesSection";
import ProfileSection from "@/pages/home/components/ProfileSection";
import Footer from "@/pages/home/components/Footer";

export default function NangLuc() {
  return (
    <main className="font-sans">
      <Navbar />

      {/* Page hero banner */}
      <div className="relative pt-20">
        <div className="relative overflow-hidden bg-[#0E5C3A] py-14 md:py-20">
          <img
            src="https://public.readdy.ai/ai/img_res/ef2a1a2b61fd21e5a4b75805b4bf4bc3.jpg"
            alt="Năng lực doanh nghiệp"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
          />
          <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
            {/* Logo + tên doanh nghiệp */}
            <div className="flex items-center justify-center gap-4 mb-6">
              <img
                src="https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/b341b5bc3acc6262cf0ddd69c309a9db.jpeg"
                alt="Logo Thuận Phát"
                className="h-16 w-auto object-contain drop-shadow-lg"
              />
              <div className="flex flex-col text-left">
                <span className="text-white font-extrabold text-2xl md:text-3xl leading-tight tracking-wide">
                  THUẬN PHÁT
                </span>
                <span className="text-white/70 text-sm leading-tight">
                  Phòng Thí Nghiệm Vật Liệu Xây Dựng
                </span>
              </div>
            </div>

            <div className="w-16 h-px bg-white/30 mx-auto mb-5"></div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              Năng lực &amp; Hồ sơ doanh nghiệp
            </h1>
            <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Tìm hiểu về năng lực chuyên môn, chứng nhận pháp lý và hồ sơ 
              năng lực đầy đủ của chúng tôi.
            </p>
            {/* Breadcrumb */}
            <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/60">
              <a href="/" className="hover:text-white transition-colors cursor-pointer">Trang chủ</a>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white/90">Năng lực doanh nghiệp</span>
            </div>

            {/* Nút giấy phép công bố */}
            <div className="mt-6">
              <a
                href="https://sxd.danang.gov.vn/chi-tiet-tin-tuc?dinhdanh=771819&cat=685651"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#D4A017] text-white px-6 py-3 rounded-md font-semibold text-sm hover:bg-[#B8891A] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-text-line"></i>
                GIẤY PHÉP CÔNG BỐ tại sở XÂY DỰNG tp ĐÀ NẴNG
              </a>
            </div>
          </div>
        </div>
      </div>

      <CapabilitiesSection />
      <ProfileSection />
      <Footer />
    </main>
  );
}
